import moment from 'moment-timezone';
import DatePicker from 'vue2-datepicker'
import custom from '@/custom';
import codes from '@/codes';
import vSelect from 'vue-select';

//restful api
import { detect as wmds } from '@/service/api/wmds'

const default_opt = () => ({
  perPage: 15,
  currentPage: 1, totalRows: 0,
  sk: '', sv: '', skt: '', opt : {}, adv: false,
  created_at_ed : moment(),
  created_at_sd : moment().subtract(1, 'month').startOf('d')
});
// props explain
// auto_refresh : auth sync enable or disable, value is boolean
// group : this component to group list, using by group dependency

const i18n_fields = {
  EN: [
    { key: 'id', thStyle: 'width: 10%', label: '#.' },
    // if (this.group !== {}) {
    //   f.push({ key: 'group.groupname', sortable: true, label: 'Group' })
    // }
    { key: 'created_at', label: 'Date', sortable: false },
    { key: 'domain', label: 'Domain', sortable: false },
    { key: 'code', label: 'DetectCode', sortable: false },
    { key: 'level', label: 'Risk level', sortable: false },
    { key: 'type', label: 'Type', sortable: false },
  ],
  KO: [
    { key: 'id', thStyle: 'width: 10%', label: '#.' },
    // if (this.group !== {}) {
    //   f.push({ key: 'group.groupname', sortable: true, label: 'Group' })
    // }
    { key: 'created_at', label: '날짜', sortable: false },
    { key: 'domain', label: '도메인', sortable: false },
    { key: 'code', label: '탐지된 코드', sortable: false },
    { key: 'level', label: '위험 수준', sortable: false },
    { key: 'type', label: '타입', sortable: false },
  ]
}

export default {
  name : "userList",
  props: ['group', "auto_refresh", "view_detail", "enable_new", "delay"],
  watch: {
    group() {
      console.log(this.group.groupname)
      console.log("watch updated props data")
      this.load()
    }
  },
  components: { DatePicker, vSelect },
  data: () => ({
    codes,
    custom,
    so : default_opt(),
    sync : { th : undefined, stop : false, interval : 15, enable : false },
    // summaryData : { enable : 0, disable : 0 },
    model : { enable : 0, disable : 0, S : 0, M : 0, U : 0, R : 0},
    hide_del : true,
    year_modal: false,
    date_modal: false,
    date_check: undefined
  }),
  computed: {
    startRow() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; },
    fields() {
      return i18n_fields[this.i18n];
    }
  },
  methods: {
    search_opt() {
      this.so.adv = !this.so.adv;
      if(this.so.adv) {
        this.so.opt['created_at_ed'] = moment().add(1, "day").startOf('d');
        // this.so.opt['last_visit_ed'] = moment()
        this.so.opt['match_type'] = 'and';
        // this.so.opt['is_alive'] = 'true';
        // this.so.opt['is_verified'] = 'true';

        this.so.sv = '';
      } else { this.reset(); }
    },
    set_op(k, v) {
      if(k == 'permissions') {
        return { name : k, value : v, op : '=' };
      } else if(v == 'false' || v == 'true') {
        return { name : k, value : v === "false" ? false : true, op : '=' }
      }
      return { name : k, value : `%${v}%`, op : 'like' }
    },
    summary() {
      let and = [];
      if(this.group) { and.push({ name : 'group_id', value : this.group.id, op : '='}) }
      // if(this.so.created_at_ed) { and.push({ name : 'end', value : this.so.created_at_ed, op : '<='}); }
      // if(this.so.created_at_sd) { and.push({ name : 'start', value : this.so.created_at_sd, op : '>='}); }

      //시작날짜 및 마지막 날짜 유무 판별
      if(!this.so.created_at_sd || !this.so.created_at_ed){
        return
      }

      // 조회 기간 최대 1년
      this.date_check = this.check_date();
      if(this.date_check > 365){
        return
      }

      //날짜 범위 오류로 +1 day 하여 백엔드로 보냄 [#5739]
      let re_created_at_ed = moment(this.so.created_at_ed).add(1, 'day').startOf('d')

      wmds.summaryDetect({ and : and, or : [], sort : [], start_at : this.so.created_at_sd, end_at : re_created_at_ed })
        .then(rs => { this.model = Object.assign(this.model, { enable : rs.body.enable, disable : rs.body.disable, S : rs.body.S, M : rs.body.M, U : rs.body.U, R : rs.body.R  }) })
        .catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
    set_sd(v, k = 'created_at') {
      let opt = this.so.opt;
      if(!v) { delete opt[`${k}_sd`]; delete opt[`${k}_ed`]; }
      else {
        let ed = opt[`${k}_ed`] || moment().startOf('d');
        let sd = opt[`${k}_sd`] || ed;
        switch(v) {
          case '-1d' : sd = moment(sd).subtract(1, 'd'); break;
          case '-1w' : sd = moment(sd).subtract(1, 'w'); break;
          case '-1m' : sd = moment(sd).subtract(1, 'M'); break;
          case 'w' : sd = moment(ed).startOf('isoweek'); break;
          case 'm' : sd = moment(ed).startOf('month'); break;
        }
        opt[`${k}_sd`] = sd.format('YYYY-MM-DD');
      }
      this.so.opt = Object.assign({}, this.so.opt);
    },
    reset() { this.so = default_opt(); this.refresh(); },
    refresh() {
      console.log("refresh", this.$route.name, new Date());
      if(this.$refs._list) {
        this.$refs._list.refresh();
        if(this.sync.enable) {
          this.sync.stop = false; this.pause();
        }
      }
    },
    pause: function() {
      this.sync.stop = !this.sync.stop;
      if(this.sync.th) { clearTimeout(this.sync.th); this.sync.th = undefined; }
      if(!this.sync.th && this.sync.stop) { this.sync.th = setTimeout(this.refresh, 1000 * this.sync.interval ); }
    },
    add() {
      if(this.view_detail !== false) {
        this.$router.push({ name: 'user', params: { id : 'add' } })
      } else {
        this.$router.push({ name: 'user', params: { id : this.$route.params.id, tag : "group" } })
      }
    },
    getRowCount () { return this.so.totalRows || 0; },
    load(ctx = {}) {
      if(!this.view_detail !== false) {
        // not component
        this.summary()
      }
      
      let so = {
        body : {
          sort : [{ name : "id", op : "desc" }],
          or : [],
          and : []
        },
        offset : (this.so.currentPage-1 || 0) * Number(this.so.perPage), limit: Number(this.so.perPage),
      }

      //시작날짜 및 마지막 날짜 유무 판별
      if(!this.so.created_at_sd || !this.so.created_at_ed){
        this.date_modal = true;
        return this.date_modal
      }

      // 조회 기간 최대 1년
      this.date_check = this.check_date();
      if(this.date_check > 365){
        this.year_modal = true;
        return this.year_modal
      }

      let re_created_at_ed = moment(this.so.created_at_ed).add(1, 'day').startOf('d');

      // if(ctx.sortBy) { so.body.sort = [ { name : ctx.sortBy, op : !ctx.sortDesc && 'desc' } ]; }
      if(this.group) { so.body.and.push({ name : 'group_id', value : this.group.id, op : '='}) }
      if(this.so.sv && (this.so.sv || '').trim()) { so.body.and.push(this.set_op(this.so.sk, this.so.sv, so)); }
      if(this.so.created_at_ed) { so.body.and.push({ name : 'created_at', value : re_created_at_ed, op : '<='}); }
      if(this.so.created_at_sd) { so.body.and.push({ name : 'created_at', value : this.so.created_at_sd, op : '>='}); }

      if(this.so.adv && this.so.opt) {
        var k = Object.keys(this.so.opt)
        for (let i = 0; i < k.length; i++) {
          if(k[i] == 'match_type') { continue; }
          let cond = undefined;

          switch (k[i]) {
            case 'is_alive':
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
            case 'is_verified':
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
            case 'created_at_sd':
              if(!this.so.opt[k[i]]) { this.$toastr.w("start Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" }
              break;
            case 'created_at_ed':
              if(!this.so.opt[k[i]]) { this.$toastr.w("end Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" }
              break;
            case 'last_visit_sd':
              if(!this.so.opt[k[i]]) { this.$toastr.w("start Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" }
              break;
            case 'last_visit_ed':
              if(!this.so.opt[k[i]]) { this.$toastr.w("end Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" }
              break;
            default:
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
          }
          if(cond.value == '%%' || cond.value === '') { continue; }
          if(this.so.opt['match_type'] == "and") { so.body.and.push(cond) }
          else { so.body.or.push(cond) }
        }
      }
      return wmds.listDetect(so).then(rs => { this.so.totalRows = rs.total; return rs.body; }).catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText))
    },
    detail(item) { this.$router.push({ name : "wmds_detect", params : { id : item.id } }); },
    sv_reset(){
      if(this.so.sv != ''){
        this.so.sv = ''
        return this.so.sv
      }
    },
    //최대 1년단위 기간 조회
    check_date(){
      let sd = moment(this.so.created_at_sd)
      let ed = moment(this.so.created_at_ed)

      let check_date = ed.diff(sd, 'day');
      return check_date
    },
  },
  created() { console.log('wmds.detect.list.vue', 'created'); },
  destroyed() { console.log('wmds.detect.list.vue', 'destroyed'); },
  mounted() { console.log('wmds.detect.list.vue', 'mounted');
    if(this.auto_refresh == true) { this.sync.enable = this.auto_refresh; }
    // if(!this.view_detail !== false) {
    //   // not component
    //   this.summary()
    // }
  },
}